import { render, staticRenderFns } from "./ProfileUpdate.vue?vue&type=template&id=94fb9076&scoped=true&"
import script from "./ProfileUpdate.vue?vue&type=script&lang=js&"
export * from "./ProfileUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fb9076",
  null
  
)

export default component.exports